import React, { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { Link } from 'react-router-dom';
import { ChevronLeft, ChevronRight, Maximize2, X, ArrowUpRight } from 'lucide-react';

// Private Card — editorial Card-Slides (20 Bilder, jeweils verlinkt auf USP-Detailseite)
export const USP_SLIDES = [
  { src: '/usp/card-01-fehlerdiagnose.webp', slug: 'fehlerdiagnose', alt: 'Fehlerdiagnose ohne teure Werkstatt — smart prüfen, Kosten sparen' },
  { src: '/usp/card-02-reparaturkosten.webp', slug: 'reparaturkosten-check', alt: 'Reparaturkosten senken — mit FuelGood Guthaben Werkstatt bezahlen' },
  { src: '/usp/card-03-kasko-selbstbehalt.webp', slug: 'kasko-selbstbehalt', alt: 'Kasko-Selbstbehalt & Schäden mit deinem Guthaben abfedern' },
  { src: '/usp/card-04-kfz-versicherung.webp', slug: 'kfz-versicherung-optimieren', alt: 'KFZ-Versicherung — KI-Check erkennt Sparpotenzial jedes Jahr' },
  { src: '/usp/card-05-autokredit.webp', slug: 'autokredit-optimieren', alt: 'Autokredit-Prüfung — bessere Konditionen finden, monatlich sparen' },
  { src: '/usp/card-07-auto-verkaufen.webp', slug: 'auto-verkaufen-service', alt: 'Mehr fürs Auto bekommen — Verkaufsservice zum festen Servicepreis' },
  { src: '/usp/card-08-fahrzeugbewertung.webp', slug: 'fahrzeugbewertung', alt: 'Kostenlose Fahrzeugbewertung — Marktwert einordnen statt Blindflug' },
  { src: '/usp/card-09-hotels.webp', slug: 'hotels-16-mio', alt: 'Hotels vergleichen — rund 1,6 Mio. Unterkünfte auf einen Blick' },
  { src: '/usp/card-10-kfz-versicherung-zurueck.webp', slug: 'kfz-versicherung-zurueck', alt: 'Bis 750 € Kfz-Versicherungsbeitrag als möglicher Reisevorteil zurück' },
  { src: '/usp/card-11-tuev-hu.webp', slug: 'tuev-hu-zurueck', alt: 'Bis 160 € für TÜV/HU — Pflichtkosten mit deinem Guthaben abfedern' },
  { src: '/usp/card-12-pannenhilfe.webp', slug: 'pannenhilfe-zurueck', alt: 'Bis 240 € für Pannenhilfe — Vorsorge, die zum Reisevorteil wird' },
  { src: '/usp/card-13-kfz-steuer.webp', slug: 'kfz-steuer-zurueck', alt: 'Bis 450 € für Kfz-Steuer — Jahreskosten als Mobilitätsvorteil zurückholen' },
  { src: '/usp/card-14-oelwechsel.webp', slug: 'oelwechsel-zurueck', alt: 'Bis 450 € für den Ölwechsel — Wartungskosten leichter machen' },
  { src: '/usp/card-15-reifenwechsel.webp', slug: 'reifenwechsel-zurueck', alt: 'Bis 250 € für den Reifenwechsel — Saisonkosten reduzieren' },
  { src: '/usp/card-16-fahrzeugaufbereitung.webp', slug: 'fahrzeugaufbereitung-zurueck', alt: 'Bis 450 € für die Fahrzeugaufbereitung — Werteindruck stärken' },
  { src: '/usp/card-17-gebrauchtwagen-check.webp', slug: 'gebrauchtwagen-check', alt: 'Bis 150 € für den Gebrauchtwagen-Check — vor dem Kauf prüfen' },
  { src: '/usp/card-18-wertgutachten.webp', slug: 'wertgutachten-zurueck', alt: 'Bis 300 € für ein fundiertes Wertgutachten — Fahrzeugwert belegen' },
  { src: '/usp/card-19-dellenreparatur.webp', slug: 'dellenreparatur-zurueck', alt: 'Bis 500 € für die Dellenreparatur — Kleinschaden fachgerecht beheben' },
  { src: '/usp/card-20-glasreparatur.webp', slug: 'glasreparatur-zurueck', alt: 'Bis 500 € für die Glasreparatur — reparieren, bevor der Steinschlag reißt' },
  { src: '/usp/card-21-leasing-rueckgabe.webp', slug: 'leasing-rueckgabe', alt: 'Bis 500 € für die Leasing-Rückgabe — Rückgabe ohne Bauchschmerzen vorbereiten' },
];

// Business/Gold — 10 Editorial-Slides (deep-linked zu /business/vorteile/*)
export const USP_SLIDES_BUSINESS = [
  { src: '/usp/business-01-fehlerdiagnose.webp', slug: 'fehlerdiagnose-flotte', alt: 'Warnleuchte im Firmenwagen — Ursache klären, bevor der Einsatz ausfällt' },
  { src: '/usp/business-02-reparaturkosten.webp', slug: 'transparente-reparaturkosten', alt: 'Reparaturkosten im Griff — Aufwand & Preis vorher planbar für Fuhrpark-Budgets' },
  { src: '/usp/business-03-kasko-selbstbehalt.webp', slug: 'kasko-selbstbehalt', alt: 'Flottenschaden begrenzen — Kasko-Selbstbehalt der Flotte gezielt abfedern' },
  { src: '/usp/business-04-kfz-versicherung.webp', slug: 'kfz-versicherung-flotte', alt: 'Flottentarif prüfen — Optimierungspotenzial bei Kfz-Versicherung erkennen' },
  { src: '/usp/business-05-fahrzeugfinanzierung.webp', slug: 'fahrzeugfinanzierungen', alt: 'Zu viel Zins im Fuhrpark — Finanzierung auf Sparpotenzial prüfen' },
  { src: '/usp/business-07-fahrzeuge-verkaufen.webp', slug: 'firmenfahrzeuge-verkaufen', alt: 'Mehr für Flottenfahrzeuge — strukturierter Fahrzeugverkauf zum Servicepreis' },
  { src: '/usp/business-08-flottenbewertung.webp', slug: 'fahrzeugbewertung-flotte', alt: 'Was ist der Fuhrpark wert? Firmenfahrzeuge nachvollziehbar bewertet' },
  { src: '/usp/business-09-hotels.webp', slug: 'geschaeftsreisen-hotels', alt: 'Geschäftsreise? Erst FuelX — rund 1,6 Mio. Unterkünfte, Mitarbeiter profitieren auch privat' },
  { src: '/usp/business-10-kfz-versicherung-zurueck.webp', slug: 'kfz-versicherungsbeitrag', alt: 'Prämien zahlen, Vorteile nutzen — bis 750 € Reisevorteil aus Kfz-Beiträgen' },
  { src: '/usp/business-11-tuev-hu.webp', slug: 'tuev-hu', alt: 'TÜV ohne Stillstand — bis 160 € für TÜV/HU-Kosten der Flotte' },
  { src: '/usp/business-12-pannenhilfe.webp', slug: 'pannenhilfe', alt: 'Bezahlt. Hoffentlich nie gebraucht — bis 240 € Pannenhilfe als Reisevorteil' },
  { src: '/usp/business-13-kfz-steuer.webp', slug: 'kfz-steuer', alt: 'Steuerkosten summieren sich — bis 450 € Kfz-Steuer als Mobilitätsvorteil' },
  { src: '/usp/business-14-oelwechsel.webp', slug: 'oelwechsel', alt: 'Ölwechsel ohne Budgetstress — bis 450 € für Wartungskosten der Flotte' },
  { src: '/usp/business-15-reifenwechsel.webp', slug: 'reifenwechsel', alt: 'Reifenwechsel für die ganze Flotte — bis 250 € für Saisonwechsel-Kosten' },
  { src: '/usp/business-16-fahrzeugaufbereitung.webp', slug: 'fahrzeugaufbereitung', alt: 'Gepflegt wirkt professionell — bis 450 € für die Aufbereitung von Firmenwagen' },
  { src: '/usp/business-17-gebrauchtwagen-check.webp', slug: 'gebrauchtwagen-check', alt: 'Gebrauchtwagen wirklich geprüft? Bis 150 € für den Check vor der Beschaffung' },
  { src: '/usp/business-18-wertgutachten.webp', slug: 'wertgutachten', alt: 'Fahrzeugwerte belastbar belegen — bis 300 € für ein fundiertes Wertgutachten' },
  { src: '/usp/business-19-dellenreparatur.webp', slug: 'dellenreparatur', alt: 'Delle im Firmenwagen? Bis 500 € für die fachgerechte Dellenreparatur' },
  { src: '/usp/business-20-glasreparatur.webp', slug: 'glasreparatur', alt: 'Steinschlag kostet Einsatzzeit — bis 500 € für die rechtzeitige Glasreparatur' },
  { src: '/usp/business-21-leasing-rueckgabe.webp', slug: 'leasing-rueckgabe', alt: 'Leasing-Rückgabe der Flotte — bis 500 € für die saubere Rückgabe ohne Streitwerte' },
];

/**
 * Produktbilder-Slider: Slide 0 = FuelX Card (custom JSX), danach die USP-Bilder.
 * Klick aufs Bild öffnet eine Vollbild-Lightbox. Optional Thumbnail-Leiste.
 */
export default function ProductImageSlider({
  firstSlide,
  cardSrc,
  cardAlt = 'FuelX Card',
  secondSlide = null,
  secondSrc = null,
  secondAlt = 'durchschnittlich 0,40 €/Liter · Benzin.Diesel.Elektro.',
  compact = false,
  showThumbnails = false,
  className = '',
  aspectClass = 'aspect-square',
  testIdPrefix = 'product-slider',
  business = false,
  hideDeepLink = false,
  onNavigate = null,
}) {
  const slides = business ? USP_SLIDES_BUSINESS : USP_SLIDES;
  const hasSecond = Boolean(secondSlide || secondSrc);
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const [lightbox, setLightbox] = useState(false);
  const touchX = useRef(null);
  const count = slides.length + 1 + (hasSecond ? 1 : 0);
  const go = (n) => setIdx(((n % count) + count) % count);

  // Slide-Reihenfolge:
  //   idx 0  → firstSlide (Card mit Flip)
  //   idx 1  → secondSlide/secondSrc (Tanken & sparen — Fuel Hero)  [optional]
  //   idx 2+ → USP-Slides
  // Für Lightbox / Thumbnails: baue eine einheitliche Liste.
  const secondEntry = hasSecond
    ? [{ src: secondSrc || null, alt: secondAlt, isSecond: true, node: secondSlide }]
    : [];
  const flatSlides = [
    { src: cardSrc, alt: cardAlt, isCard: true },
    ...secondEntry,
    ...slides,
  ];

  useEffect(() => {
    if (paused || lightbox) return undefined;
    const t = setTimeout(() => setIdx((i) => (i + 1) % count), 4500);
    return () => clearTimeout(t);
  }, [idx, paused, lightbox, count]);

  // Benachbarte Slides vorladen — kein sichtbares Nachladen beim Slide-Wechsel
  useEffect(() => {
    [1, 2].forEach((off) => {
      const s = flatSlides[(idx + off) % count];
      if (s?.src) { const im = new window.Image(); im.src = s.src; }
    });
  }, [idx, count]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!lightbox) return undefined;
    const onKey = (e) => {
      if (e.key === 'Escape') setLightbox(false);
      if (e.key === 'ArrowRight') go(idx + 1);
      if (e.key === 'ArrowLeft') go(idx - 1);
    };
    window.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';
    return () => {
      window.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [lightbox, idx]); // eslint-disable-line react-hooks/exhaustive-deps

  const onTouchStart = (e) => { setPaused(true); touchX.current = e.touches[0].clientX; };
  const onTouchEnd = (e) => {
    setPaused(false);
    if (touchX.current === null) return;
    const dx = e.changedTouches[0].clientX - touchX.current;
    if (Math.abs(dx) > 40) go(dx < 0 ? idx + 1 : idx - 1);
    touchX.current = null;
  };

  const arrowCls = `absolute z-10 rounded-full bg-stone-950/70 hover:bg-stone-950/90 text-white shadow-lg backdrop-blur-sm flex items-center justify-center transition-all ring-1 ring-white/15 ${
    compact ? 'w-7 h-7' : 'w-10 h-10'
  }`;
  const iconCls = compact ? 'w-3.5 h-3.5' : 'w-5 h-5';

  const lightboxUI = lightbox && createPortal(
    <div
      className="fixed inset-0 z-[130] bg-stone-950/95 backdrop-blur-sm flex items-center justify-center animate-in fade-in duration-200"
      onClick={(e) => { e.stopPropagation(); setLightbox(false); }}
      onTouchStart={onTouchStart}
      onTouchEnd={onTouchEnd}
      role="dialog"
      aria-modal="true"
      aria-label="Produktbild in Vollansicht"
      data-testid={`${testIdPrefix}-lightbox`}
    >
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setLightbox(false); }}
        className="absolute top-4 right-4 z-20 w-10 h-10 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors"
        aria-label="Vollansicht schließen"
        data-testid={`${testIdPrefix}-lightbox-close`}
      >
        <X className="w-5 h-5" strokeWidth={2} />
      </button>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); go(idx - 1); }}
        className="absolute left-3 sm:left-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors"
        aria-label="Vorheriges Bild"
        data-testid={`${testIdPrefix}-lightbox-prev`}
      >
        <ChevronLeft className="w-5 h-5" strokeWidth={2.5} />
      </button>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); go(idx + 1); }}
        className="absolute right-3 sm:right-6 top-1/2 -translate-y-1/2 z-20 w-10 h-10 sm:w-11 sm:h-11 rounded-full bg-white/10 hover:bg-white/20 text-white flex items-center justify-center transition-colors"
        aria-label="Nächstes Bild"
        data-testid={`${testIdPrefix}-lightbox-next`}
      >
        <ChevronRight className="w-5 h-5" strokeWidth={2.5} />
      </button>

      <div className="w-full max-w-4xl px-2 sm:px-20" onClick={(e) => e.stopPropagation()}>
        <img
          src={flatSlides[idx].src || cardSrc}
          alt={flatSlides[idx].alt}
          className="w-full max-h-[85vh] object-contain rounded-2xl"
          data-testid={`${testIdPrefix}-lightbox-image`}
        />
      </div>

      <div
        className="absolute bottom-5 left-1/2 -translate-x-1/2 z-20 rounded-full bg-white/10 backdrop-blur-sm ring-1 ring-white/15 px-3.5 py-1.5 text-white text-sm font-medium tabular-nums"
        data-testid={`${testIdPrefix}-lightbox-counter`}
      >
        {idx + 1}<span className="text-white/45"> / {count}</span>
      </div>
    </div>,
    document.body
  );

  return (
    <div className="w-full">
      <div
        className={`relative overflow-hidden ${aspectClass} select-none ${className}`}
        onTouchStart={onTouchStart}
        onTouchEnd={onTouchEnd}
        onMouseEnter={() => setPaused(true)}
        onMouseLeave={() => setPaused(false)}
        data-testid={testIdPrefix}
      >
        <div
          className="flex h-full transition-transform duration-500 ease-out cursor-zoom-in"
          style={{ transform: `translateX(-${idx * 100}%)` }}
          onClick={(e) => { e.stopPropagation(); setLightbox(true); }}
        >
          <div className="w-full h-full flex-shrink-0">{firstSlide}</div>
          {hasSecond && (
            <div className="w-full h-full flex-shrink-0" data-testid={`${testIdPrefix}-second-slide`}>
              {secondSlide || (
                <img
                  src={secondSrc}
                  alt={secondAlt}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  draggable={false}
                />
              )}
            </div>
          )}
          {slides.map((s) => {
            const linkTo = !hideDeepLink && s.slug ? (business ? `/business/vorteile/${s.slug}` : `/vorteile/${s.slug}`) : null;
            const imgEl = (
              <img
                src={s.src}
                alt={s.alt}
                className="w-full h-full object-cover"
                loading="lazy"
                draggable={false}
              />
            );
            return (
              <div key={s.src} className="w-full h-full flex-shrink-0 relative group">
                {linkTo ? (
                  <Link
                    to={linkTo}
                    onClick={(e) => { e.stopPropagation(); onNavigate?.(); }}
                    className="block w-full h-full cursor-pointer focus:outline-none"
                    aria-label={`${s.alt} — Details ansehen`}
                    data-testid={`${testIdPrefix}-slide-link-${s.slug}`}
                  >
                    {imgEl}
                    <span className={`absolute z-20 inline-flex items-center gap-1.5 rounded-full bg-emerald-400 text-stone-950 font-semibold tracking-tight shadow-lg ring-1 ring-emerald-500/30 transition-all duration-300 group-hover:scale-105 group-hover:shadow-xl pointer-events-none ${
                      compact
                        ? 'top-1.5 right-9 px-2.5 py-1 text-[10px]'
                        : 'top-3 right-14 px-3.5 py-1.5 text-xs'
                    }`}>
                      Details ansehen
                      <ArrowUpRight className={compact ? 'w-3 h-3' : 'w-3.5 h-3.5'} strokeWidth={2.6} />
                    </span>
                  </Link>
                ) : imgEl}
              </div>
            );
          })}
        </div>

        {/* Dezente Verläufe: Steuerelemente bleiben lesbar, ohne das Bild zu „überladen" */}
        <div className={`absolute inset-x-0 top-0 z-[5] pointer-events-none bg-gradient-to-b from-stone-950/35 to-transparent ${compact ? 'h-10' : 'h-14'}`} aria-hidden="true" />
        <div className={`absolute inset-x-0 bottom-0 z-[5] pointer-events-none bg-gradient-to-t from-stone-950/45 via-stone-950/10 to-transparent ${compact ? 'h-12' : 'h-16'}`} aria-hidden="true" />

        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); setLightbox(true); }}
          className={`absolute z-10 rounded-full bg-white/85 text-stone-900 shadow-md flex items-center justify-center hover:bg-white transition-colors ${
            compact ? 'top-1.5 right-1.5 w-6 h-6' : 'top-3 right-3 w-8 h-8'
          }`}
          aria-label="Bild vergrößern"
          data-testid={`${testIdPrefix}-zoom`}
        >
          <Maximize2 className={iconCls} strokeWidth={2.2} />
        </button>

        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); go(idx - 1); }}
          className={`${arrowCls} ${compact ? 'bottom-1.5 right-11' : 'bottom-3 right-16'}`}
          aria-label="Vorheriges Produktbild"
          data-testid={`${testIdPrefix}-prev`}
        >
          <ChevronLeft className={iconCls} strokeWidth={2.5} />
        </button>
        <button
          type="button"
          onClick={(e) => { e.stopPropagation(); go(idx + 1); }}
          className={`${arrowCls} ${compact ? 'bottom-1.5 right-1.5' : 'bottom-3 right-3'}`}
          aria-label="Nächstes Produktbild"
          data-testid={`${testIdPrefix}-next`}
        >
          <ChevronRight className={iconCls} strokeWidth={2.5} />
        </button>

        {/* Bild-Zähler statt 21 Klick-Punkte — kein Clutter, keine Überlappung mit den Pfeilen */}
        <div
          className={`absolute z-10 rounded-full bg-stone-950/70 text-white backdrop-blur-sm ring-1 ring-white/15 font-medium tabular-nums pointer-events-none ${
            compact ? 'left-1.5 bottom-2 px-2 py-0.5 text-[10px]' : 'left-3 bottom-4 px-2.5 py-1 text-[11px]'
          }`}
          data-testid={`${testIdPrefix}-counter`}
        >
          {idx + 1}<span className="text-white/45"> / {count}</span>
        </div>

        {/* Schlanke Fortschrittsleiste am unteren Rand */}
        <div className="absolute bottom-0 inset-x-0 h-1 bg-white/15 z-10 pointer-events-none" aria-hidden="true">
          <div
            className="h-full bg-emerald-400 transition-[width] duration-500 ease-out"
            style={{ width: `${((idx + 1) / count) * 100}%` }}
            data-testid={`${testIdPrefix}-progress`}
          />
        </div>
      </div>

      {showThumbnails && (
        <div className="mt-3 -mx-4 sm:mx-0 px-4 sm:px-0 flex sm:flex-wrap gap-2 sm:gap-1.5 overflow-x-auto sm:overflow-visible snap-x snap-mandatory sm:snap-none scrollbar-hide" data-testid={`${testIdPrefix}-thumbs`}>
          {flatSlides.map((s, i) => (
            <button
              key={s.src || `slide-${i}`}
              type="button"
              onClick={(e) => { e.stopPropagation(); go(i); }}
              className={`snap-start shrink-0 w-14 sm:w-[calc((100%-0.375rem*9)/10)] aspect-square rounded-lg overflow-hidden border-2 transition-all ${
                i === idx ? 'border-emerald-500 opacity-100' : 'border-transparent opacity-60 hover:opacity-100'
              } ${s.isCard ? 'bg-stone-900' : ''}`}
              aria-label={s.alt}
              data-testid={`${testIdPrefix}-thumb-${i}`}
            >
              <img src={s.src ? (s.src.startsWith('/usp/') ? s.src.replace('/usp/', '/usp/thumbs/') : s.src) : cardSrc} alt="" className={`w-full h-full ${s.isCard ? 'object-contain' : 'object-cover'}`} loading="lazy" draggable={false} />
            </button>
          ))}
        </div>
      )}

      {lightboxUI}
    </div>
  );
}
